export const faqMacroCategories = [
  { key: 'no-veicolo-noleggio', text: 'Non ho un veicolo a noleggio' },
  { key: 'si-veicolo-noleggio', text: 'Ho un veicolo a noleggio'}
]